module.exports = __webpack_public_path__ + "img/zuijia_48.094b7a1a.png";